import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import AuthContextProvider from "./contexts/auth/provider";
import AppContextProvider from "./contexts/app/provider";
import { ConfigProvider, Spin } from "antd";
import arEG from "antd/locale/ar_EG";
import NotificationContextProvider from "./contexts/notifications/provider";
import "chart.js/auto"; // Register all chart types
import "react-simple-keyboard/build/css/index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const App = React.lazy(() => import("./App"));

root.render(
  // <React.StrictMode>
  <ConfigProvider
    direction="rtl"
    locale={arEG}
    theme={{
      components: {
        DatePicker: {
          colorLink: "#F5DEB4",
          colorLinkHover: "#7E4F25",
          // colorLink: "#F5DEB4",
          // colorLinkHover: "#7E4F25",
        },
        Spin: { colorBgBase: "red", colorBgContainer: "red" },
      },
      token: {
        // colorPrimary: "#1DA1F2",
        colorPrimary: "#750A00",
        colorTextSecondary: "rgb(49,7,3)",

        fontFamily: "Cairo",
      },
    }}
  >
    <Suspense
      fallback={
        <div
          style={{
            height: "100vh",
            width: "100vw",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin size="default" />
        </div>
      }
    >
      <BrowserRouter>
        <AuthContextProvider>
          <AppContextProvider>
            <NotificationContextProvider>
              <App />
            </NotificationContextProvider>
          </AppContextProvider>
        </AuthContextProvider>
      </BrowserRouter>
    </Suspense>
  </ConfigProvider>

  // </React.StrictMode>
);
